<template>
  <div id="app">
    <Nutheader
      brand="Nutbed"
      @updateUrlBase="handleUpdateUrlBase"
      :user="username"
      :urlBaseInit="urlBase"
      @dropToken="handleDropToken"
      @getToken="handleGetToken"
      @changeSource="handleChangeSource"
    ></Nutheader>
    <Nutbody :urlBase="urlBase" :token="token" :username="username"></Nutbody>
  </div>
</template>

<script>
import Nutheader from "./components/Nutheader";
import Nutbody from "./components/Nutbody";
import localforage from "localforage/dist/localforage.min.js";
import $ from "jquery/dist/jquery.min.js";
export default {
  name: "app",
  components: {
    Nutheader,
    Nutbody
  },
  routes:Nutbody.routes,
  data: function() {
    return {
      token: "",
      username: "",
      urlBase: ""
      // urlBase: "http://192.168.31.38:3000",
      // urlBase: "http://www.nutbrain.cn:8081",
    };
  },
  computed: {
    userUrl: function() {
      return this.urlBase + "/users";
    }
  },
  watch: {
    token: function() {
      this.getUsername();
    }
  },
  created: async function() {
    await localforage.getItem("token").then(token => {
      this.token = token || "";
    });
    await localforage.getItem("urlBase").then(urlBase=>{
      this.urlBase=urlBase || "";
    })
    await this.getUsername();
  },
  methods: {
    getUsername() {
      $.get(this.userUrl, { token: this.token }).then(result => {
        if (result.success) {
          this.username = result.username;
        } else {
          this.username = "";
        }
      });
    },
    handleChangeSource(source) {
      this.source = source;
    },
    handleGetToken(token) {
      this.token = token;
      localforage.setItem("token", this.token);
    },
    handleDropToken() {
      this.token = "";
      localforage.setItem("token", this.token);
    },
    handleUpdateUrlBase(urlBase) {
      this.urlBase = urlBase;
      localforage.setItem("urlBase",this.urlBase);
    }
  }
};
</script>

<style>
h1{
  margin:20px auto;
}
</style>
